import React from 'react';
import { useContainerStyles } from '../styles/container';
import theme from './theme';
import Hero from './Hero';
import Place from './Place';
import Partner from './Partner';
import AppLayout from '../../front/Layout/AppLayout';
import { ThemeProvider } from '@material-ui/core/styles';
import AuthDialogContextProvider from '../../front/components/AuthDialog/AuthDialogContextProvider';

const Hida = ({
  plans = [],
  businesses = [],
  authenticated,
  ...headerProps
}) => {
  const classes = useContainerStyles();
  return (
    <AuthDialogContextProvider>
      <AppLayout {...headerProps} authenticated={authenticated}>
        <ThemeProvider theme={theme}>
          <div>
            <div className={classes.root}>
              <Hero />
            </div>
            <Place
              businesses={businesses}
              plans={plans}
              isAuthenticated={authenticated}
            />
            <div className={classes.root}>
              <Partner />
            </div>
          </div>
        </ThemeProvider>
      </AppLayout>
    </AuthDialogContextProvider>
  );
};

export default Hida;
